import {ProductSlimInfo} from "./product-slim-info";

export class MenuCategoryWithSlimProducts {
    public categoryId: string = "";
    public categoryName: string = "";
    public products: ProductSlimInfo[] = [];

    constructor() {
    }
}